<template>
    <div class="page-wrapper">
        <div class="page">
            <ul class="page-nav">
                <li><router-link to="/layout/index">首页</router-link></li>
                <li><router-link to="/layout/association-introduction">关于我们</router-link></li>
                <li class="currentNode"><a>协会构架</a></li>
            </ul>
            <div class="page-main">
                <ul class="vertical-nav">
                    <li class="rootMenu"><a>关于我们</a></li>
                    <li><router-link to="/layout/association-introduction">协会简介</router-link></li>
                    <li><router-link to="/layout/association-articles">协会章程</router-link></li>
                    <li><router-link to="/layout/association-structure">协会构架</router-link></li>
                    <li><router-link to="/layout/join-us">申请入会</router-link></li>
                    <li><router-link to="" class="active">联系方式</router-link></li>
                </ul>
                <div class="page-content">
                    <h3>联系方式</h3>
                    <p><strong>地址：</strong>{{ address }}</p>
                    <p><strong>邮箱：</strong>{{ webSite }}</p>
                    <p><strong>电话：</strong>{{ tel }}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {
    getXiehuiModel,
    getXiehuiVIP
} from '@services/indexService.js'
export default {
    name:"",
    data() {
        return {
            id: 5, // 5
            tel: '',   
            address: '',
            webSite: '', 
            titleLink: '',
        }
    },
    created() {
        this.getXiehuiModel();
    },
    methods: {
        handleCurrentChange(pageNum) {

        },
        getXiehuiModel() {
            let params = {
                id: this.id
            };
            getXiehuiModel(params).then(res => {
                console.log(res);
                if (res.Code == 1) {
                    this.tel = res.Data.Tel;
                    this.address = res.Data.Address;
                    this.webSite = res.Data.EstablishedTime;
                } else {
                    this.$message.error("联系方式请求失败");
                }
            })
        }
    }
}
</script>

<style scoped>
.page-content {
    padding: 30px;
    height: 300px;
    box-sizing: border-box;
}
.page-content h3{
    text-align:center;
    margin-bottom: 50px;
}
.page-content p {
    font-family: 思源黑体 CN;
    font-size: 16px;
    line-height: 28.64px;
    color: #4E5969;
    margin-bottom: 20px;
    width:520px;
    margin:0 auto;
}
.page-content p strong {
    color: #1D2129;
}
.a_disabled {
    cursor: not-allowed;
}
</style>